import { http } from '../request'
import { fetchAllPages, type PageResponse } from '@/utils/pagination'
import {
  type ManagementEntity,
  normalizePageResponse
} from './shared'

export interface RoomDto extends ManagementEntity {
  id: number
  name: string
  campusId?: number
  campusName?: string
  buildingId?: number
  building: string
  floor?: number
  capacity: number
  type: string
  equipment?: string[]
}

type RoomPayload = {
  name: string
  campusId: number | undefined
  buildingId: number | undefined
  floor: number | undefined
  capacity: number | undefined
  type: string
  equipment: string[] | undefined
  status: string
  remark: unknown
}

function toRoomPayload(payload: unknown): RoomPayload {
  const room = payload as Partial<RoomDto> & Record<string, unknown>
  return {
    name: String(room.name ?? '').trim(),
    campusId: room.campusId,
    buildingId: room.buildingId,
    floor: room.floor != null ? Number(room.floor) : undefined,
    capacity: room.capacity != null ? Number(room.capacity) : undefined,
    type: String(room.type ?? '普通教室').trim(),
    equipment: room.equipment,
    status: String(room.status ?? '启用').trim() || '启用',
    remark: room.remark
  }
}

async function listAllRooms(): Promise<RoomDto[]> {
  return fetchAllPages<RoomDto>({
    fetchFn: (params) => http.get<PageResponse<RoomDto>>('/data-management/rooms', params),
    normalizeFn: (raw) => normalizePageResponse<RoomDto>(raw)
  })
}

export const roomApi = {
  async list(): Promise<RoomDto[]> {
    return listAllRooms()
  },
  async create(payload: unknown): Promise<RoomDto> {
    const response = await http.post<RoomDto>('/data-management/rooms', toRoomPayload(payload))
    return response.data
  },
  async update(id: number, payload: unknown): Promise<RoomDto> {
    const response = await http.put<RoomDto>(`/data-management/rooms/${id}`, toRoomPayload(payload))
    return response.data
  },
  async remove(id: number): Promise<void> {
    await http.delete<void>(`/data-management/rooms/${id}`)
  }
}
